import React from "react";
import "./Textimagesection.css";

const TextImageSection = ({ text, imagesrc, alttext, left = true }) => {
  return (
    <div className={`text-image-section ${left ? "left" : "right"}`}>
      {left && (
        <div className="image-content">
          <img src={imagesrc} alt={alttext} />
        </div>
      )}
      <div className="text-content">
        <p>{text}</p>
      </div>
      {!left && (
        <div className="image-content">
          <img src={imagesrc} alt={alttext} />
        </div>
      )}
    </div>
  );
};

export default TextImageSection;
